import { useTransportMutation } from "@/transport"

export function useConversationUpdateRunTagsTransport() {
  return useTransportMutation("updateRunTags")
}
